const footerNav = [
  { href: "#overview", label: "口碑总览" },
  { href: "#works", label: "作品评分榜" },
  { href: "#dimensions", label: "评分维度解析" },
  { href: "#reviews", label: "深度影评" },
  { href: "#audience", label: "观众观后感" },
  { href: "#guide", label: "选片指南" },
  { href: "#faq", label: "常见问题" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="rounded-lg bg-primary-500 text-background-50 p-6 md:p-10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div className="max-w-2xl">
            <h2 className="font-heading text-2xl md:text-3xl font-bold leading-snug">
              选好今晚要看哪一部了吗？
            </h2>
            <p className="mt-3 text-sm md:text-base text-background-100/90 leading-relaxed">
              回到作品榜，按题材和评分挑一部，或者看看其他观众的观后感再做决定。
              口碑、评分与观后感都在这一个页面里。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <a
              href="#works"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 text-primary-700 text-sm md:text-base font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-bar-chart-box-line" />
              返回作品榜
            </a>
            <a
              href="#faq"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-100/70 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-question-line" />
              查看常见问题
            </a>
          </div>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-film-line text-xl" />
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">
                风驰影院
              </span>
            </div>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              一个专注整理风驰影院作品口碑、评分与观后感的参考站。
              帮你在观影之前，先快速判断一部作品好看吗、值不值得看。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-950">页面导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-y-2 gap-x-4">
              {footerNav.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-950">内容说明</h3>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              本站评分与口碑为对观众印象与观后感的综合整理，仅作观影参考，
              不代表官方评分或绝对结论。具体放映与分级信息，请以实际发布内容为准。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 风驰影院口碑站 · 内容仅供参考
          </p>
          <p className="text-xs text-foreground-500 flex items-center gap-1.5">
            <i className="ri-information-line" />
            口碑数据持续更新中
          </p>
        </div>
      </div>
    </footer>
  );
}